import { getRatingApi } from "api/match";

/// ✅ 전문가 평균평점
export const getTotalRating = async (id) => {
  try {
    const response = await getRatingApi(id);
    if (!Array.isArray(response) || response.length === 0) return 0;
    const total = response.reduce((acc, row) => acc + (Number(row.score) || 0), 0);
    return Math.floor((total / response.length) * 10) / 10;
  } catch (error) {
    console.error("failed getTotalRating:", error);
    return 0;
  }
};
